export default __webpack_public_path__ + "static/media/radiology.d3dbdd4e.png";